module.exports = __webpack_public_path__ + "img/rentishengwuzhong.ecdd7b8c.png";